import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/auth/login'
  },
  {
    path: '/404',
    name: '404',
    component: () => import('../views/pages/NotFound/index')
  },
  {
    path: '/not_found',
    name: 'not_found',
    component: () => import('../views/pages/NotFound/index_custom')
  },
  {
    path: '/auth',
    name: 'auth',
    component: () => import('../views/auth/AuthLayout'),
    children: [
      {
        path: '/',
        redirect: "/auth/login",
        component: () => import('../views/auth/Login')
      },
      {
        path: '/auth/login',
        name: 'login',
        component: () => import('../views/auth/Login')
      },
      {
        path: '/auth/change-password',
        name: 'changePassword',
        component: () => import('../views/auth/changePassword')
      }
    ]
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import('../views/admin/AdminLayout'),
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'list-manager',
        name: 'manager',
        component: () => import('../views/admin/manager'),
        default: true,
        meta: {
          model: 'admin',
          requiresAuth: true,
        }
      },
      {
        path: 'list-manager/add',
        name: 'addManager',
        component: () => import('../views/admin/manager/function'),
        meta: {
          model: 'admin',
          requiresAuth: true,
        }
      },
      {
        path: 'list-manager/edit/:id',
        name: 'editManager',
        component: () => import('../views/admin/manager/function'),
        meta: {
          model: 'admin',
          requiresAuth: true,
        }
      },
      {
        path: 'list-manager/view/:id',
        name: 'viewManager',
        component: () => import('../views/admin/manager/view'),
        meta: {
          model: 'admin',
          requiresAuth: true,
        }
      },
      {
        path: 'import-document',
        name: 'importDoc',
        component: () => import('../views/admin/import_document'),
        default: true,
        meta: {
          model: 'document',
          requiresAuth: true,
        }
      },
      {
        path: 'import-document/add',
        name: 'addDoc',
        component: () => import('../views/admin/import_document/add'),
        meta: {
          model: 'document',
          requiresAuth: true,
        }
      },
      {
        path: 'import-document/edit/:id',
        name: 'editDoc',
        component: () => import('../views/admin/import_document/edit'),
        meta: {
          model: 'document',
          requiresAuth: true,
        }
      },
      // {
      //   path: 'import-document/view/:id',
      //   name: 'viewDoc',
      //   component: () => import('../views/admin/import_document/view'),
      //   meta: {
      //     model: 'document',
      //     requiresAuth: true,
      //   }
      // },
      {
        path: 'list-document',
        name: 'lstDoc',
        component: () => import('../views/admin/list_document'),
        default: true,
        meta: {
          model: 'list_document',
          requiresAuth: true,
        }
      },
      {
        path: 'list-document/edit/:id',
        name: 'editLstDoc',
        component: () => import('../views/admin/list_document/edit'),
        meta: {
          model: 'list_document',
          requiresAuth: true,
        }
      },
      {
        path: 'statement-detail',
        name: 'stateDetail',
        component: () => import('../views/admin/statement_detail'),
        meta: {
          model: 'statement_detail',
          requiresAuth: true,
        }
      },
      {
        path: 'statement-return-court',
        name: 'stateReturnCourt',
        component: () => import('../views/admin/statement_return_court'),
        meta: {
          model: 'statement_return_court',
          requiresAuth: true,
        }
      },
      {
        path: 'statement-return-court/edit/:id',
        name: 'editStateReturnCourt',
        component: () => import('../views/admin/statement_return_court/edit'),
        meta: {
          model: 'statement_return_court',
          requiresAuth: true,
        }
      },
      {
        path: 'compute-salary',
        name: 'computeSalary',
        component: () => import('../views/admin/compute_salary'),
        meta: {
          model: 'compute_salary',
          requiresAuth: true,
        }
      },
      {
        path: 'compute-salary/edit/:id',
        name: 'editComputeSalary',
        component: () => import('../views/admin/compute_salary/edit'),
        meta: {
          model: 'compute_salary',
          requiresAuth: true,
        }
      },
      {
        path: 'compute-salary-outbound',
        name: 'computeSalaryOutbound',
        component: () => import('../views/admin/compute_salary_outbound'),
        meta: {
          model: 'compute_salary_outbound',
          requiresAuth: true,
        }
      },
      {
        path: 'payroll-employee',
        name: 'parollEmployee',
        component: () => import('../views/admin/payroll_employee'),
        meta: {
          model: 'payroll_employee',
          requiresAuth: true,
        }
      },
      {
        path: 'report-complete-late',
        name: 'reportCompleteLate',
        component: () => import('../views/admin/report_complete_late'),
        meta: {
          model: 'report_complete_late',
          requiresAuth: true,
        }
      },
      {
        path: 'report-complete-late/edit/:id',
        name: 'editReportCompleteLate',
        component: () => import('../views/admin/report_complete_late/edit'),
        meta: {
          model: 'report_complete_late',
          requiresAuth: true,
        }
      },
      {
        path: 'report-uncomplete-late',
        name: 'reportUnCompleteLate',
        component: () => import('../views/admin/report_uncomplete_late'),
        meta: {
          model: 'report_uncomplete_late',
          requiresAuth: true,
        }
      },
      {
        path: 'report-uncomplete-late/edit/:id',
        name: 'editReportUnCompleteLate',
        component: () => import('../views/admin/report_uncomplete_late/edit'),
        meta: {
          model: 'report_uncomplete_late',
          requiresAuth: true,
        }
      },
      {
        path: 'report-comparison',
        name: 'reportComparison',
        component: () => import('../views/admin/report_comparison'),
        meta: {
          model: 'report_comparison',
          requiresAuth: true,
        }
      },
      {
        path: 'report-comparison/edit/:id',
        name: 'editReportComparison',
        component: () => import('../views/admin/report_comparison/edit'),
        meta: {
          model: 'report_comparison',
          requiresAuth: true,
        }
      },
      // {
      //   path: 'list-ver',
      //   name: 'ver',
      //   component: () => import('../views/admin/ver'),
      //   default: true,
      //   meta: {
      //     model: 'ver',
      //     requiresAuth: true,
      //   }
      // },
      // {
      //   path: 'list-ver/add',
      //   name: 'addVer',
      //   component: () => import('../views/admin/ver/function'),
      //   meta: {
      //     model: 'ver',
      //     requiresAuth: true,
      //   }
      // },
      // {
      //   path: 'list-ver/edit/:id',
      //   name: 'editVer',
      //   component: () => import('../views/admin/ver/function'),
      //   meta: {
      //     model: 'ver',
      //     requiresAuth: true,
      //   }
      // },
      // {
      //   path: 'list-ver/view/:id',
      //   name: 'viewVer',
      //   component: () => import('../views/admin/ver/view'),
      //   meta: {
      //     model: 'ver',
      //     requiresAuth: true,
      //   }
      // },
      {
        path: 'list-notification',
        name: 'notification',
        component: () => import('../views/admin/notification'),
        default: true,
        meta: {
          model: 'notification',
          requiresAuth: true,
        }
      },
      {
        path: 'list-notification/add',
        name: 'addNotification',
        component: () => import('../views/admin/notification/function'),
        meta: {
          model: 'notification',
          requiresAuth: true
        }
      },
      {
        path: 'list-group_permission',
        name: 'group_permission',
        component: () => import('../views/admin/group_permission'),
        default: true,
        meta: {
          model: 'group_permission',
          requiresAuth: true,
        }
      },
      {
        path: 'list-group_permission/add',
        name: 'addgroup_permission',
        component: () => import('../views/admin/group_permission/function'),
        meta: {
          model: 'group_permission',
          requiresAuth: true,
        }
      },
      {
        path: 'list-group_permission/edit/:id',
        name: 'editgroup_permission',
        component: () => import('../views/admin/group_permission/function'),
        meta: {
          model: 'group_permission',
          requiresAuth: true,
        }
      },
      {
        path: 'list-group_permission/view/:id',
        name: 'viewgroup_permission',
        component: () => import('../views/admin/group_permission/view'),
        meta: {
          model: 'group_permission',
          requiresAuth: true,
        }
      },
      {
        path: 'list-holiday_setting',
        name: 'holiday_setting',
        component: () => import('../views/admin/holiday_setting'),
        default: true,
        meta: {
          model: 'holiday_setting',
          requiresAuth: true,
        }
      },
      {
        path: 'list-holiday_setting/add',
        name: 'addholiday_setting',
        component: () => import('../views/admin/holiday_setting/function'),
        meta: {
          model: 'holiday_setting',
          requiresAuth: true,
        }
      },
      {
        path: 'list-holiday_setting/edit/:id',
        name: 'editholiday_setting',
        component: () => import('../views/admin/holiday_setting/function'),
        meta: {
          model: 'holiday_setting',
          requiresAuth: true,
        }
      },
      {
        path: 'list-holiday_setting/view/:id',
        name: 'viewholiday_setting',
        component: () => import('../views/admin/holiday_setting/view'),
        meta: {
          model: 'holiday_setting',
          requiresAuth: true,
        }
      },
      {
        path: 'list-status_tongdat/add',
        name: 'addstatus_tongdat',
        component: () => import('../views/admin/status_tongdat/function'),
        meta: {
          model: 'status_tongdat',
          requiresAuth: true,
        }
      },
      {
        path: 'list-users_dpv',
        name: 'users_dpv',
        component: () => import('../views/admin/users_dpv'),
        default: true,
        meta: {
          model: 'users_dpv',
          requiresAuth: true,
        }
      },
      {
        path: 'list-users_dpv/add',
        name: 'addusers_dpv',
        component: () => import('../views/admin/users_dpv/function'),
        meta: {
          model: 'users_dpv',
          requiresAuth: true,
        }
      },
      {
        path: 'list-users_dpv/edit/:id',
        name: 'editusers_dpv',
        component: () => import('../views/admin/users_dpv/function'),
        meta: {
          model: 'users_dpv',
          requiresAuth: true,
        }
      },
      {
        path: 'list-users_dpv/view/:id',
        name: 'viewusers_dpv',
        component: () => import('../views/admin/users_dpv/view'),
        meta: {
          model: 'users_dpv',
          requiresAuth: true,
        }
      },
      {
        path: 'list-court_account',
        name: 'court_account',
        component: () => import('../views/admin/court_account'),
        default: true,
        meta: {
          model: 'court_account',
          requiresAuth: true,
        }
      },
      {
        path: 'list-court_account/add',
        name: 'addcourt_account',
        component: () => import('../views/admin/court_account/function'),
        meta: {
          model: 'court_account',
          requiresAuth: true,
        }
      },
      {
        path: 'list-court_account/edit/:id',
        name: 'editcourt_account',
        component: () => import('../views/admin/court_account/function'),
        meta: {
          model: 'court_account',
          requiresAuth: true,
        }
      },
      {
        path: 'list-office_tpl',
        name: 'office_tpl',
        component: () => import('../views/admin/office_tpl'),
        default: true,
        meta: {
          model: 'office_tpl',
          requiresAuth: true,
        }
      },
      {
        path: 'list-office_tpl/add',
        name: 'addoffice_tpl',
        component: () => import('../views/admin/office_tpl/function'),
        meta: {
          model: 'office_tpl',
          requiresAuth: true,
        }
      },
      {
        path: 'list-office_tpl/edit/:id',
        name: 'editoffice_tpl',
        component: () => import('../views/admin/office_tpl/function'),
        meta: {
          model: 'office_tpl',
          requiresAuth: true,
        }
      },
      {
        path: 'list-office_tpl/view/:id',
        name: 'viewoffice_tpl',
        component: () => import('../views/admin/office_tpl/view'),
        meta: {
          model: 'office_tpl',
          requiresAuth: true,
        }
      },
      {
        path: 'list-office_agency',
        name: 'office_agency',
        component: () => import('../views/admin/office_agency'),
        default: true,
        meta: {
          model: 'office_agency',
          requiresAuth: true,
        }
      },
      {
        path: 'list-office_agency/add',
        name: 'addoffice_agency',
        component: () => import('../views/admin/office_agency/function'),
        meta: {
          model: 'office_agency',
          requiresAuth: true,
        }
      },
      {
        path: 'list-office_agency/edit/:id',
        name: 'editoffice_agency',
        component: () => import('../views/admin/office_agency/function'),
        meta: {
          model: 'office_agency',
          requiresAuth: true,
        }
      },
      {
        path: 'list-office_agency/view/:id',
        name: 'viewoffice_agency',
        component: () => import('../views/admin/office_agency/view'),
        meta: {
          model: 'office_agency',
          requiresAuth: true,
        }
      },
      {
        path: 'list-area',
        name: 'area',
        component: () => import('../views/admin/area'),
        default: true,
        meta: {
          model: 'area',
          requiresAuth: true,
        }
      },
      {
        path: 'list-area/add',
        name: 'addarea',
        component: () => import('../views/admin/area/function'),
        meta: {
          model: 'area',
          requiresAuth: true,
        }
      },
      {
        path: 'list-area/edit/:id',
        name: 'editarea',
        component: () => import('../views/admin/area/function'),
        meta: {
          model: 'area',
          requiresAuth: true,
        }
      },
      {
        path: 'list-area/view/:id',
        name: 'viewarea',
        component: () => import('../views/admin/area/view'),
        meta: {
          model: 'area',
          requiresAuth: true,
        }
      },
      {
        path: 'list-office_vplk',
        name: 'office_vplk',
        component: () => import('../views/admin/office_vplk'),
        default: true,
        meta: {
          model: 'office_vplk',
          requiresAuth: true,
        }
      },
      {
        path: 'list-office_vplk/add',
        name: 'addoffice_vplk',
        component: () => import('../views/admin/office_vplk/function'),
        meta: {
          model: 'office_vplk',
          requiresAuth: true,
        }
      },
      {
        path: 'list-office_vplk/edit/:id',
        name: 'editoffice_vplk',
        component: () => import('../views/admin/office_vplk/function'),
        meta: {
          model: 'office_vplk',
          requiresAuth: true,
        }
      },
      {
        path: 'list-office_vplk/view/:id',
        name: 'viewoffice_vplk',
        component: () => import('../views/admin/office_vplk/view'),
        meta: {
          model: 'office_vplk',
          requiresAuth: true,
        }
      },
      {
        path: 'list-users_tdv',
        name: 'users_tdv',
        component: () => import('../views/admin/users_tdv'),
        default: true,
        meta: {
          model: 'users_tdv',
          requiresAuth: true,
        }
      },
      {
        path: 'list-users_tdv/add',
        name: 'addusers_tdv',
        component: () => import('../views/admin/users_tdv/function'),
        meta: {
          model: 'users_tdv',
          requiresAuth: true,
        }
      },
      {
        path: 'list-users_tdv/edit/:id',
        name: 'editusers_tdv',
        component: () => import('../views/admin/users_tdv/function'),
        meta: {
          model: 'users_tdv',
          requiresAuth: true,
        }
      },
      {
        path: 'list-users_tdv/view/:id',
        name: 'viewusers_tdv',
        component: () => import('../views/admin/users_tdv/view'),
        meta: {
          model: 'users_tdv',
          requiresAuth: true,
        }
      },
      {
        path: 'list-salary_pricelist',
        name: 'salary_pricelist',
        component: () => import('../views/admin/salary_pricelist'),
        default: true,
        meta: {
          model: 'salary_pricelist',
          requiresAuth: true,
        }
      },
      {
        path: 'list-salary_pricelist/add',
        name: 'addsalary_pricelist',
        component: () => import('../views/admin/salary_pricelist/function'),
        meta: {
          model: 'salary_pricelist',
          requiresAuth: true,
        }
      },
      {
        path: 'list-salary_pricelist/edit/:id',
        name: 'editsalary_pricelist',
        component: () => import('../views/admin/salary_pricelist/function'),
        meta: {
          model: 'salary_pricelist',
          requiresAuth: true,
        }
      },
      {
        path: 'list-salary_pricelist/view/:id',
        name: 'viewsalary_pricelist',
        component: () => import('../views/admin/salary_pricelist/view'),
        meta: {
          model: 'salary_pricelist',
          requiresAuth: true,
        }
      },
      {
        path: 'list-salary_pricelist_province',
        name: 'salary_pricelist_province',
        component: () => import('../views/admin/salary_pricelist_province'),
        default: true,
        meta: {
          model: 'salary_pricelist_province',
          requiresAuth: true,
        }
      },
      {
        path: 'list-salary_pricelist_province/add',
        name: 'addsalary_pricelist_province',
        component: () => import('../views/admin/salary_pricelist_province/function'),
        meta: {
          model: 'salary_pricelist_province',
          requiresAuth: true,
        }
      },
      {
        path: 'list-salary_pricelist_province/edit/:id',
        name: 'editsalary_pricelist_province',
        component: () => import('../views/admin/salary_pricelist_province/function'),
        meta: {
          model: 'salary_pricelist_province',
          requiresAuth: true,
        }
      },
      {
        path: 'list-salary_pricelist_province/view/:id',
        name: 'viewsalary_pricelist_province',
        component: () => import('../views/admin/salary_pricelist_province/view'),
        meta: {
          model: 'salary_pricelist_province',
          requiresAuth: true,
        }
      },
      {
        path: 'list-organ_pricelist_province',
        name: 'organ_pricelist_province',
        component: () => import('../views/admin/organ_pricelist_province'),
        default: true,
        meta: {
          model: 'organ_pricelist_province',
          requiresAuth: true,
        }
      },
      {
        path: 'list-organ_pricelist',
        name: 'organ_pricelist',
        component: () => import('../views/admin/organ_pricelist'),
        default: true,
        meta: {
          model: 'organ_pricelist',
          requiresAuth: true,
        }
      },
      {
        path: 'list-organ_pricelist/add',
        name: 'addorgan_pricelist',
        component: () => import('../views/admin/organ_pricelist/function'),
        meta: {
          model: 'organ_pricelist',
          requiresAuth: true,
        }
      },
      {
        path: 'list-organ_pricelist/edit/:id',
        name: 'editorgan_pricelist',
        component: () => import('../views/admin/organ_pricelist/function'),
        meta: {
          model: 'organ_pricelist',
          requiresAuth: true,
        }
      },
      {
        path: 'list-organ_pricelist/view/:id',
        name: 'vieworgan_pricelist',
        component: () => import('../views/admin/organ_pricelist/view'),
        meta: {
          model: 'organ_pricelist',
          requiresAuth: true,
        }
      },
      {
        path: 'report-comparison-agency',
        name: 'reportComparisonAgency',
        component: () => import('../views/admin/report_comparison_agency'),
        meta: {
          model: 'report_comparison_agency',
          requiresAuth: true,
        }
      },
      {
        path: 'report-docs-tdv',
        name: 'reportDocsTdv',
        component: () => import('../views/admin/report_docs_tdv'),
        meta: {
          model: 'report_docs_tdv',
          requiresAuth: true,
        }
      },
      {
        path: 'report-general-employee-inventory',
        name: 'reportGeneralEmployeeInventory',
        component: () => import('../views/admin/report_general_employee_inventory'),
        meta: {
          model: 'report_general_employee_inventory',
          requiresAuth: true,
        }
      },
    ]
  }
]

const router = new VueRouter({
  routes,
  mode: 'history'
})


export default router